import HNavbar from "../../components/Base/HNavbar";

const PinesCeaOlimpia = ({ subRoutes }) => <HNavbar links={subRoutes} isIcon />;


export default PinesCeaOlimpia

